// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__3QoWQ","spin":"Loader_spin__1EFms"};